import { Item } from '@openx/components-targeting/Targeting/shared/SelectedItems/Item';
import { getAgeRange } from './demographicsUtils';

export const DemographicsAgeSegmentsListItem = ({ range, isLastItem, onAgeDelete }) => (
  <Item testId="age-item" readonly={false} item={range} onRemove={onAgeDelete}>
    {getAgeRange({ min: range.min, max: range.max })}
    {!isLastItem && ','}
  </Item>
);
